import React, { Fragment } from "react";

import img13 from "../../../images/service/White-Label Crypto Exchange Development/1.png";
import img14 from "../../../images/service/White-Label Crypto Exchange Development/2.png";
import img15 from "../../../images/service/White-Label Crypto Exchange Development/3.png";

import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import TheorySection from "../../../components/PageSection/Theory";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";

// --------------------------------------------------
// DATA
// --------------------------------------------------

const serviceCards = [
  {
    icon: sIcon1,
    title: "White-Label Exchange Setup",
    content:
      "Launch a ready-made crypto exchange platform with your branding, domain, and business logic.",
  },
  {
    icon: sIcon2,
    title: "Custom UI & Branding",
    content:
      "Fully customizable user interface, admin dashboard, and trading layouts.",
  },
  {
    icon: sIcon3,
    title: "Liquidity Integration",
    content:
      "Connect global liquidity providers and market-making solutions for instant trading volume.",
  },
];

const benefits = [
  {
    title: "Faster Time to Market",
    description:
      "Launch your crypto exchange in weeks instead of months with pre-built infrastructure.",
    icon: sIcon1,
  },
  {
    title: "Cost-Effective Solution",
    description:
      "Avoid high development costs while accessing enterprise-grade exchange technology.",
    icon: sIcon2,
  },
  {
    title: "Scalable Architecture",
    description:
      "Built to scale effortlessly as users, trades, and assets grow.",
    icon: sIcon3,
  },
  {
    title: "Advanced Security",
    description:
      "Multi-layer security with encryption, cold wallets, and DDoS protection.",
    icon: sIcon4,
  },
  {
    title: "Revenue Flexibility",
    description:
      "Custom fee structures including trading fees, withdrawal fees, and listing fees.",
    icon: sIcon5,
  },
  {
    title: "Compliance Ready",
    description:
      "KYC, AML, and audit-friendly features for regulatory preparedness.",
    icon: sIcon6,
  },
];

const faqs = [
  {
    q: "What is a white-label crypto exchange?",
    a: "A white-label exchange is a ready-made crypto trading platform that can be branded and launched under your business name.",
  },
  {
    q: "Can I customize features after launch?",
    a: "Yes. The platform supports modular upgrades, feature additions, and UI changes.",
  },
  {
    q: "Is liquidity included?",
    a: "Yes. We integrate liquidity providers and market-making services.",
  },
  {
    q: "Do you offer post-launch support?",
    a: "Yes. We provide maintenance, updates, and technical support after deployment.",
  },
];

// --------------------------------------------------
// PAGE COMPONENT
// --------------------------------------------------

export default function WhiteLabelCryptoExchangeDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="White-Label Crypto Exchange Development"
        pagesub="Launch your branded crypto exchange faster and smarter"
      />

      {/* ================= HERO ================= */}
      <HeroSection
        title={
          <>
            Launch Your Own{" "}
            <span className="gradient-text">White-Label Crypto Exchange</span>
          </>
        }
        subtitle={`Our white-label cryptocurrency exchange solutions help businesses
launch secure, scalable, and fully branded trading platforms with minimal effort
and faster go-to-market.`}
        buttonText="Launch My Exchange"
        buttonLink="/contact"
        image={img13}
        imageAlt="White-Label Crypto Exchange Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="What Is White-Label Crypto Exchange Development?"
        image={img14}
        paragraphs={[
          "White-label crypto exchange development allows businesses to launch a fully functional trading platform using pre-built exchange software. Instead of developing an exchange from scratch, companies can customize an existing framework with their branding, business rules, and target market requirements.",
          "This approach significantly reduces development time, technical complexity, and cost, while still offering enterprise-grade performance, security, and scalability. White-label exchanges are ideal for startups, fintech firms, and enterprises entering the crypto market.",
        ]}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Why Choose a White-Label Exchange Solution?"
        image={img15}
        paragraphs={[
          "Launching a crypto exchange traditionally requires deep technical expertise, infrastructure planning, and regulatory awareness. White-label solutions remove these barriers by providing a tested and proven platform that can be deployed quickly.",
          "Businesses gain the flexibility to focus on growth, marketing, and user acquisition while relying on a robust backend system that supports high trading volumes, multiple assets, and secure transactions.",
        ]}
      />

      {/* ================= SERVICES ================= */}
      <ServiceCardsSection
        title="Our White-Label Exchange Services"
        cards={serviceCards}
      />

      {/* ================= BENEFITS ================= */}
      <Benefit
        title="Benefits of White-Label Crypto Exchange Development"
        benefits={benefits}
      />

      {/* ================= KEY FEATURES ================= */}
      <KeyFeaturesSection
        title="Key Features of Our White-Label Exchange"
        subtitle="Built for reliability, performance, and business growth."
        features={[
          {
            icon: sIcon1,
            title: "Advanced Trading Engine",
            description:
              "High-speed matching engine for real-time trade execution.",
          },
          {
            icon: sIcon2,
            title: "Multi-Currency Support",
            description:
              "Trade crypto-crypto and crypto-fiat pairs seamlessly.",
          },
          {
            icon: sIcon3,
            title: "Admin Control Panel",
            description:
              "Powerful admin dashboard to manage users, fees, and assets.",
          },
          {
            icon: sIcon4,
            title: "Wallet Management",
            description:
              "Integrated hot & cold wallets with multi-signature security.",
          },
          {
            icon: sIcon5,
            title: "Liquidity Management",
            description:
              "Integrated order books and external liquidity providers.",
          },
          {
            icon: sIcon6,
            title: "Compliance Tools",
            description:
              "KYC, AML, and transaction monitoring capabilities.",
          },
        ]}
      />

      {/* ================= WHY CHOOSE US ================= */}
      <WhyChooseUsSection
        items={[
          "Proven White-Label Exchange Solutions",
          "Quick Deployment & Customization",
          "End-to-End Exchange Support",
        ]}
      />

      {/* ================= FAQ ================= */}
      <FaqSection faqs={faqs} />

      {/* ================= CTA ================= */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
